export function initEventFilter() {
  const eventWrapper = document.querySelector(".event-wrapper");
  const allEvents = document.querySelectorAll(".event-wrapper .single-event");
  const filterButtons = document.querySelectorAll(".filter-button");

  /**
   * Filters events based on their data-status attribute.
   * @param {string} filter - The status to show ('future', 'ongoing', 'past').
   */
  function filterEvents(filter) {
    let hasVisibleEvents = false;

    // Loop through all event articles
    allEvents.forEach((event) => {
      if (event.dataset.status === filter) {
        event.classList.remove("hidden");
        event.style.display = "";
        hasVisibleEvents = true;
      } else {
        event.classList.add("hidden");
        event.style.display = "none";
      }
    });

    // Remove any existing "no events" message
    const existingMessage = document.getElementById("no-events-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    // If no events are visible for the selected filter, show a message
    if (!hasVisibleEvents && eventWrapper) {
      eventWrapper.insertAdjacentHTML(
        "beforeend",
        `<p id="no-events-message">No ${filter} events found on this category.</p>`
      );
    }
  }

  // On page load, show "Future" events by default.
  if (allEvents.length > 0) {
    filterEvents("ongoing");
  }

  // Add a click event listener to each filter button.
  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Update the active state on buttons
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Get the filter category from the button's data attribute
      const selectedFilter = button.dataset.filter;

      // Run the filtering function
      filterEvents(selectedFilter);
    });
  });
}
